import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { CheckboxTextComponent } from '../checkbox-text/checkbox-text';
@NgModule({
	declarations: [CheckboxTextComponent],
	imports: [TranslateModule.forChild(), IonicPageModule.forChild(CheckboxTextComponent)],
	exports: [CheckboxTextComponent]
})
export class CheckboxTextModule {}



// WEBPACK FOOTER //
// ./src/components/myria/checkbox-text/checkbox-text.module.ts